import React from "react";
import Backdrop from "@/components/base/backdrop";
import PageLayout from "@/components/base/page-layout";
import withErrorBoundary from "@/components/hoc/with-error-boundary";
import { Params, useParams } from "react-router-dom";
import useQueryInventory from "@/hooks/queries/useQueryInventory";
import InventoryDetails from "@/components/inventory-details";

const InventoryDetailsPage: React.FC = () => {
  const { iid } = useParams<Params>();
  const { data: inventory, isFetching } = useQueryInventory();

  const inventoryItem = inventory?.find(
    (item) => item.inventory_item_id === iid
  );

  if (!inventoryItem) {
    return <Backdrop loading={isFetching} />;
  }

  return (
    <PageLayout title="Inventory item">
      <InventoryDetails item={inventoryItem} />
    </PageLayout>
  );
};

export default withErrorBoundary({ component: "InventoryDetailsPage" })(
  InventoryDetailsPage
);
